const baseStyle = {
  opacity: 0.6,
  borderWidth: 1,
};

export default {
  baseStyle,
};
